.staticTwoFactor {
  visibility: visible;
}